import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, filter, map, startWith } from 'rxjs';
import { WidthPreset } from '@vendasta/galaxy/page';

@Component({
  selector: 'app-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss'],
})
export class PageContentComponent implements OnInit {
  isExternalGlxyPage$: Observable<boolean>;
  FullWidth = WidthPreset.Full;

  constructor(private router: Router, private readonly location: Location) {}

  ngOnInit(): void {
    const currentUrl$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this.location.path()),
    );

    this.isExternalGlxyPage$ = currentUrl$.pipe(map((url) => isExternalGlxyPage(url)));
  }
}

function isExternalGlxyPage(url: string): boolean {
  const externalGlxyPagePaths = ['/crm', '/products'];
  return externalGlxyPagePaths.some((path) => url.startsWith(path));
}
